import { Drawer, Space } from 'antd';
import React, { useMemo } from 'react';
import { Container } from '@/ui';
import ConfigureStepItem from '@/components/common/SidePanels/QuestionnaireSidePanelForm/ConfigureStepItem';

export const QuestionnaireSidePanel = ({
  steps,
  setStep,
  step,
  isStrings,
  isInProcess,
  isOpen,
  onClose
}) => {
  step = step - 1;

  // Mark identical siblings to only show the last step
  const [groupedSteps, displayedSteps, sortedSteps] = useMemo(() => {
    // these get updated by the .map() to avoid another iteration
    let displayCount = 0;
    const skippedSteps = [];
    const sortedSteps = steps.sort((a, b) =>
      a.newNumber ? a.newNumber - b.newNumber : a.number ? a.number - b.newNumber : 0
    );
    const sortedStepsSections = isStrings ? steps : sortedSteps.map((item) => item.section);

    const groupedSteps = sortedStepsSections.map((step, index) => {
      if (skippedSteps.includes(index)) {
        displayCount++;
        return [index, index - 1, null];
      }

      const hiddenCount = index - displayCount;

      if (step !== sortedStepsSections[index + 1]) {
        displayCount++;
        return [index, index - hiddenCount, true];
      }

      let statusIndex = index;
      const indexes = [statusIndex];
      while (
        step === sortedStepsSections[statusIndex + 1] &&
        statusIndex < sortedStepsSections.length
      ) {
        statusIndex++;
        indexes.push(statusIndex);
        skippedSteps.push(index + 1);
      }

      return [
        // The index used for the status in the panel (last of the group)
        indexes,
        // The index used for the display in the panel (first of the group)
        index - hiddenCount,
        // Do not display the step
        false
      ];
    });

    return [groupedSteps, displayCount, sortedSteps];
  }, [steps]);

  return (
    <>
      <Container $mdHidden>
        <Space direction='vertical' size={20}>
          {groupedSteps
            .filter((item) => item[2] !== null)
            .map(([statusIndex, displayIndex, show], index) => (
              <ConfigureStepItem
                key={index}
                currentStep={groupedSteps?.[step]?.[0]}
                initialStep={groupedSteps?.[step]?.[0]}
                label={
                  Array.isArray(statusIndex)
                    ? isStrings
                      ? sortedSteps[statusIndex[0]]
                      : sortedSteps[statusIndex[0]].section
                    : isStrings
                      ? sortedSteps[statusIndex]
                      : sortedSteps[statusIndex].section
                }
                step={statusIndex}
                stepNumber={displayIndex + 1}
                show={show}
                onClick={setStep ? () => setStep(displayIndex) : null}
                isInProcess={isInProcess}
              />
            ))}
        </Space>
      </Container>

      <Drawer placement='left' open={isOpen} onClose={onClose}>
        <Space direction='vertical' size={20}>
          {groupedSteps
            .filter((item) => item[2] !== null)
            .map(([statusIndex, displayIndex, show], index) => (
              <ConfigureStepItem
                key={index}
                currentStep={groupedSteps?.[step]?.[0]}
                initialStep={groupedSteps?.[step]?.[0]}
                label={
                  Array.isArray(statusIndex)
                    ? isStrings
                      ? sortedSteps[statusIndex[0]]
                      : sortedSteps[statusIndex[0]].section
                    : isStrings
                      ? sortedSteps[statusIndex]
                      : sortedSteps[statusIndex].section
                }
                step={statusIndex}
                stepNumber={displayIndex + 1}
                show={show}
                onClick={setStep ? () => setStep(displayIndex) : null}
                isInProcess={isInProcess}
              />
            ))}
        </Space>
      </Drawer>
    </>
  );
};
